import axios from 'axios';
import { isEmpty } from 'lodash';
import { create } from 'zustand';
import BoyPic from '../images/boy.png';
import GirlPic from '../images/girl.png';
import { updateUserTimezone } from '../utils/api';
import { useMutation } from 'react-query';
const initial_model = {
  user: null,
  careRecipients: [],
  caregivers: [],
  selectedRecipient: localStorage.getItem('selectedRecipient') || '',
  screenWidth: window.innerWidth,
  deviceActivities: null,
  features: {},
};

const useStore = create((set) => ({
  ...initial_model,
  updateCareRecipients: (data) => set(() => ({ careRecipients: data })),
  updateCaregivers: (data) => set(() => ({ caregivers: data })),
  updateUser: (user) => set(() => ({ user })),
  updateSelectedRecipient: (data) => set(() => ({ selectedRecipient: data })),
  clearUser: () => set(() => initial_model),
  updateScreenWidth: (data) => set(() => ({ screenWidth: data })),
  updateDeviceActivities: (data) => set(() => ({ deviceActivities: data })),
  updateFeatures: (data) => set(() => ({ features: data })),
}));

export const updateUser = (user) => useStore.getState().updateUser(user);
export const updateScreenWidth = (data) => useStore.getState().updateScreenWidth(data);
export const updateDeviceActivities = (data) => useStore.getState().updateDeviceActivities(data);
export const clearUser = () => {
  useStore.getState().clearUser();
};
export const updateSelectedRecipient = (data) => {
  useStore.getState().updateSelectedRecipient(data);
  localStorage.setItem('selectedRecipient', data);
};

export const getCareRecipients = async ({ userId, token = null }) => {
  try {
    const { data } = await axios.get(
      process.env.REACT_APP_EXPRESS_URL + `/api/canCare/user/${userId}/getCareRecipients`,
      {
        headers: {
          'Content-Type': 'application/json',
          authorization: token || localStorage.getItem('auth'),
        },
      },
    );

    let careRec = {};

    for (let user of data?.data) {
      careRec = {
        ...careRec,
        [user?.careRecipientId?._id]: {
          ...user,
          ...user?.careRecipientId,
          imageUrl: !isEmpty(user?.careRecipientId?.userInfo?.imageUrl)
            ? user?.careRecipientId?.userInfo?.imageUrl
            : user?.careRecipientId?.userInfo?.gender === 'female'
              ? GirlPic
              : BoyPic,
        },
      };
    }

    useStore.getState().updateCareRecipients(careRec);
  } catch (error) {
    console.log('getCareRecipients error =====> ', error);
  }
};
export const getCaregivers = async ({ userId, token = null }) => {
  try {
    const { data } = await axios.get(process.env.REACT_APP_EXPRESS_URL + `/api/canCare/user/${userId}/getCaregivers`, {
      headers: {
        'Content-Type': 'application/json',
        authorization: token || localStorage.getItem('auth'),
      },
    });

    let caregiver = {};

    for (let user of data?.data) {
      caregiver = {
        ...caregiver,
        [user.caregiverId?._id]: {
          ...user.caregiverId,
          devices: user?.devices || [],
        },
      };
    }

    useStore.getState().updateCaregivers(caregiver);
  } catch (error) {
    console.log('getCaregivers error =====> ', error);
  }
};

export const loadFeatures = async () => {
  const env = process.env.REACT_APP_ENV || 'dev';
  try {
    const features = await import(`../features.${env}.json`);
    useStore.getState().updateFeatures(features.default);
    return;
  } catch (error) {
    console.error(`Error loading features for environment "${env}":`, error);
    return {};
  }
};
loadFeatures();

// Helper function: convert system timezone to offset like +5 or +5:30
const getTimezoneOffset = () => {
  const offsetMinutes = new Date().getTimezoneOffset(); // in minutes, e.g. -300 for UTC+5
  const sign = offsetMinutes > 0 ? '-' : '+'; // positive offsetMinutes means behind UTC
  const absMinutes = Math.abs(offsetMinutes);
  const hours = Math.floor(absMinutes / 60);
  const minutes = absMinutes % 60;

  return minutes > 0 ? `${sign}${hours}:${minutes.toString().padStart(2, '0')}` : `${sign}${hours}`;
};

export const checkAndUpdateTimezone = async () => {
  const { user, updateUser } = useStore.getState();
  if (!user) return;

  const localOffset = getTimezoneOffset();
  if (user.timezone === localOffset) return;

  try {
    await updateUserTimezone({ userId: user._id, offset: localOffset });
    updateUser({ ...user, timezone: localOffset });
    console.log('Timezone updated successfully:', localOffset);
  } catch (error) {
    console.error('Error updating timezone =====>', error);
  }
};

export default useStore;
